import { requestAnimationFrame } from 'CommonUtils/raf.js';
import {doScrolling} from 'CommonUtils/scroll.js'
let langCode = languageAttributes.languageCode;

let lang = languageAttributes.name, broker = languageAttributes.broker;

langCode = location.hostname == "www.iforexsa.com" || location.hostname == "www.iforex-saudi.com" ? 'ar_sa' : langCode;


if (location.pathname.startsWith('/hi/')) {
   lang = 'Hindi-translated';
}

if ((location.hostname == "www.iforexarab.com" || location.hostname == "local.iforexarab.com") && location.pathname.startsWith('/en/')) {
   lang = 'English-AR';
}

switch (langCode) {
   case 'fr':
      lang = 'Francais'; break;
   case 'it':
      lang = 'Italian'; break;
   case 'pl':
      lang = 'Polish'; break;
   case 'hu':
      lang = 'Hungarian'; break;
   case 'tw':
      lang = 'Taiwanese'; break;
   case 'en_sa':
      lang = 'Saudi';
      broker = 99;
      break;
   case 'ar_sa':
      lang = 'Arabic';
      broker = 99;
      break;
   case 'kz':
      lang = 'Russian';
      break;
}



const env = window.getparam('env') || 'prod';
const script = document.createElement('script');
script.async = true;
script.defer = true;
script.src = `https://content.webapi-services.net/web_assets/scripts/legaljs/${broker}/${lang}/main.js?env=${env}`;


const app = document.getElementById('legal-app');

function render() {
   window.FxLegalDocuments.startLegalDocumentsApp(app);
   requestAnimationFrame(() => app.classList.remove('loading')); 

   setTimeout(function () {

      let hash = window.location.hash.split('#')[1];
      let target = document.getElementById(hash);
      let main_header = $('.main-header');

      if (window.location.hash) {
         doScrolling(target.getBoundingClientRect().top - document.body.getBoundingClientRect().top - main_header.height(), 500);
      }
   }, 500);
}
script.onload = render;

requestAnimationFrame(() => document.body.appendChild(script));

